function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "transparent",
  d: "M10 13c-4 0-7 3-7 3l1 3h12l1-3s-3-3-7-3z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "outline",
  fill: "#919EAB",
  d: "M17.707 15.293c.268.268.36.664.24 1.023l-1 3c-.135.41-.517.684-.947.684H4c-.43 0-.813-.275-.95-.684l-1-3c-.12-.36-.025-.755.243-1.023C2.427 15.158 5.635 12 10 12s7.572 3.158 7.707 3.293zM15.28 18l.56-1.687C14.92 15.56 12.687 14 10 14c-2.703 0-4.927 1.558-5.843 2.31L4.72 18h10.56zM10 2c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zm0 8c2.757 0 5-2.243 5-5s-2.243-5-5-5-5 2.243-5 5 2.243 5 5 5z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/user.52871fed.svg";
export { SvgComponent as ReactComponent };